<template>
	<div class="info-page">
		<b-container>
			<div v-html="content"/>
		</b-container>
	</div>
</template>

<script>
import {decodeBase64} from "@/helper/String";

export default {

	props: {
		content64: {
			type: String,
			required: true
		}
	},

	computed: {
		content ()
		{
			return decodeBase64(this.content64);
		}
	}
}
</script>
